import { decryptor, encryptor } from './decryptor';

const WL_STORAGE_KEY = 'wl';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IWhiteLabelCache extends Record<string, any> {
  fingerprint?: string;
}

// Institution is resolved server-side by request host, so hostname doubles as the tenant identity.
export const getWhiteLabelFingerprint = (): string => globalThis.location.hostname;

export const clearWhiteLabelCache = (): void => {
  sessionStorage.removeItem(WL_STORAGE_KEY);
};

export const readWhiteLabelCache = (): IWhiteLabelCache | null => {
  const storedWL = sessionStorage.getItem(WL_STORAGE_KEY);

  if (!storedWL) {
    return null;
  }

  const decrypted = decryptor(storedWL);

  if (!decrypted) {
    clearWhiteLabelCache();

    return null;
  }

  try {
    const parsed = JSON.parse(decrypted);

    if (!parsed || parsed.fingerprint !== getWhiteLabelFingerprint()) {
      clearWhiteLabelCache();

      return null;
    }

    return parsed;
  } catch {
    clearWhiteLabelCache();

    return null;
  }
};

export const writeWhiteLabelCache = (theme: Record<string, unknown>): void => {
  const encryptedData = encryptor(JSON.stringify({ ...theme, fingerprint: getWhiteLabelFingerprint() }));

  if (encryptedData) {
    sessionStorage.setItem(WL_STORAGE_KEY, encryptedData);
  }
};
